import React, { useContext } from 'react';
import { AppContext } from '../../App';
import { motion } from 'framer-motion';
import { CountryFlag } from '../../Utils/flags';

const Athlete = ({ result, heat, config }) => {
  const appConfig = useContext(AppContext).config;
  const { animation } = appConfig;
  const itemAnimation = {
    hidden: {
      y: 20,
      opacity: 0,
      transition: {
        duration: animation.duration,
        ease: animation.ease
      }
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: animation.duration,
        ease: animation.ease
      }
    }
  };

  const qualifiedStatus = (result) => {
    const qualified = result.result_text
      ? result.result_text
      : result.qualified === ''
      ? result.total
      : result.qualified;

    switch (qualified.toLowerCase()) {
      case 'sportsdsq':
      case 'unfairdsq':
        return 'DSQ';
      case 'other':
        return '';
      default:
        return qualified;
    }
  };

  return (
    <motion.tr variants={itemAnimation} positionTransition>
      <td
        className={`rank font-bold nowrap text-left font-mono${
          !result.rank || result.rank === 0 || !heat.resultIsOfficial ? ' empty' : ''
        }`}
      >
        {heat.resultIsOfficial ? result.rank === 0 || `${result.rank}.` : ''}
      </td>
      <td className={`gate nowrap${!result.gate ? ' empty' : ''}`}>
        {!result.gate || `G${result.gate}`}
      </td>
      <td
        className={`${config.leaveNamesCapitalization ? '' : 'text-capitalize '}fullname`}
      >
        <img className="flag" src={CountryFlag(result.nation)} alt={result.nation} />{' '}
        {config.leaveNamesCapitalization ? (
          <>
            {result.firstname} {result.lastname}
          </>
        ) : (
          <>
            {result.firstname.toLowerCase()} {result.lastname.toLowerCase()}
          </>
        )}
      </td>
      <td className="info font-mono nowrap text-right">
        {heat.resultIsOfficial && qualifiedStatus(result)}
      </td>
    </motion.tr>
  );
};

export { Athlete };
